// src/services/predictiveAlertService.js
import { authenticatedFetch } from './api';

/**
 * Fetches the active predictive maintenance alerts (assets at risk).
 */
export const fetchAssetsAtRisk = async () => {
  try {
    // --- FIX: The correct endpoint is /api/v1/predictive/alerts ---
    // This route is handled by predictiveMaintenanceController.getAlerts
    // which uses predictiveMaintenanceAlertModel.findAll(req.query).
    // The new route file validates for 'isResolved' and 'limit'.
    const endpoint = '/predictive/alerts?isResolved=false&limit=10';
    
    const data = await authenticatedFetch(endpoint);
    
    return data; // Expects { success: true, data: [...], pagination: {...} }
  } catch (error) {
    console.error("Error fetching assets at risk:", error.message);
    throw error;
  }
};